import { configureStore } from '@reduxjs/toolkit';
import beacon4FiltersReducer            from '../reducers/Beacon4FiltersReducer';
import beacon4KpiDataReducer            from '../reducers/Beacon4KpiDataReducer';
import beacon4RagReducer                from '../reducers/Beacon4RagReducer';
import beacon4PerformanceKpiDataReducer from '../reducers/Beacon4PerformanceKpiDataReducer';
import beacon4PerformanceAdminReducer   from '../reducers/Beacon4PerformanceAdminReducer';

const Beacon4Store = configureStore({
	reducer: {
		beacon4Filters:            beacon4FiltersReducer,
		beacon4KpiData:            beacon4KpiDataReducer,
		beacon4Rag:                beacon4RagReducer,
		beacon4PerformanceKpiData: beacon4PerformanceKpiDataReducer,
		beacon4PerformanceAdmin:   beacon4PerformanceAdminReducer,
	},
});

export default Beacon4Store;
